export default "/static/dashboard/build/app/img/v2/525323b562d96dce48caa233f60b6467.png";